export default function hasMatchingAncestor(
  source: Element,
  callback: (item: Element) => boolean
): boolean {
  let current: Element | null = source
  do {
    if (callback(current)) {
      return true
    }
    current = current.parentElement
  } while (current != null)

  return false
}
